import React, {useEffect, useState} from 'react'

import StandardForm from '../forms/StandardForm';

import useExchangeStore from "../../stores/ExchangesStore"
import useUserStore from "../../stores/UserStore"

import axios from 'axios';
import Cookies from 'js-cookie'
import { AiFillDelete } from "react-icons/ai";
import { FiDelete } from "react-icons/fi";

function Exchanges() {

  const {exchanges_list, fetchExchanges} = useExchangeStore()
  const {userID} = useUserStore()
  const token = Cookies.get('token')

  const add_exchanges_list = ["binance", "binance_futures", "bybit_SPOT", "bybit_USDT_PERP", "kucoin", "kucoin_futures"]
  const input_list = ["exchange_name", "api_key", "api_secret"]
  const url = '/api/make_exchange'
  const strat = 'exchange'
  const details = "undefined"

  // useEffect(()=>  {
  //   const fetchData = async () => {
  //       try {
  //           await fetchExchanges()
  //       } catch (error) {
  //           console.log("Error fetching user settings", error);
  //       }
  //   }
  //   fetchData();
  // }, [])

  const kill_exchange = async (exchange_id) => {
    const url = '/api/kill_exchange'
    try {
        await axios({
            headers: { Authorization: token },
            timeout : 2000,
            url : url,
            data : {exchange_id : userID+'@'+exchange_id},
            method: 'POST'
        })
        } catch (err) {
          console.log(err)
        }
}   
  return (
    <div className='widget_body'>
      <ul  className="ul_exchange">     
        {Object.keys(exchanges_list).map(function(exchange) {
            return <li className="exchange_state_container" key={exchange} onClick={() => kill_exchange(exchange)}>
              {/* <AiFillDelete onClick={() => kill_exchange(exchange)} className="delete_icon no_drag" /> */}
              <h3 className="exchange_title" > {exchange.replaceAll('_', ' ')} </h3>
              <FiDelete  className="delete_icon no_drag" />
              </li>
        })}
      </ul>
      <div className="add_exchange_form_container">
        <h3 className="add_exchange_title">Add an exchange</h3>
        <StandardForm input_list={input_list} strat={strat} url={url} button_list={add_exchanges_list} details={details} />
      </div>

    </div>
  )
}

export default Exchanges;